import { render, staticRenderFns } from "./PatientListDetail.vue?vue&type=template&id=9298a79a"
import script from "./PatientListDetail.vue?vue&type=script&lang=js"
export * from "./PatientListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports